export default __webpack_public_path__ + "6c31e709d3ebea94faa2590b4c68b625.png";